
<div class="flex flex-col lg:flex-row min-h-screen w-full">
    <!-- Left Side - Green Background with Content (Hidden on mobile/tablet) -->
    <div class="hidden lg:flex lg:w-1/2 relative overflow-hidden">
        <div class="absolute inset-0 bg-[#016934] z-0"></div>
        <div class="absolute inset-0 z-1">
            <img src="/assets/images/background/bg.png" alt="" class="w-full h-full object-cover opacity-30">
        </div>
        <div class="relative z-10 flex items-center h-full p-8 xl:p-12">
            <div>
                <h1 class="text-white text-4xl xl:text-6xl font-bold leading-tight">Connexion à l'espace Admin</h1>
                <div class="w-24 h-1 bg-[#F39200] my-6"></div>
                <p class="text-white text-2xl xl:text-3xl mt-6 leading-relaxed">Accédez à votre compte pour gérer</p>
                <p class="text-white text-2xl xl:text-3xl mt-1 leading-relaxed">efficacement vos réunions</p>
            </div>
        </div>
    </div>
    
    <!-- Right Side - Login Form (Full width on mobile/tablet, half width on desktop) -->
    <div class="w-full lg:w-1/2 bg-white flex flex-col justify-between min-h-screen">
        <!-- Main Content -->
        <div class="flex flex-col items-center justify-center flex-grow px-4 py-8 sm:px-6 md:px-8 lg:px-12">
            <div class="w-full max-w-md">
                <!-- Logo -->
                <div class="flex justify-center mb-6 sm:mb-8">
                    <img src="/assets/images/logo/oneci_logo.svg" alt="ONECI Logo" class="h-12 sm:h-16 md:h-20">
                </div>
    
                <!-- Welcome Text -->
                <div class="text-center mb-6 sm:mb-8">
                    <h2 class="text-[#016934] text-lg sm:text-xl md:text-2xl font-bold mb-2 leading-tight px-4">
                        Veuillez saisir le code OTP envoyé par mail pour accéder à votre compte
                    </h2>
                </div>
    
                <!-- Login Form -->
                <form [formGroup]="otpForm" (ngSubmit)="onSubmit()" class="space-y-6">
                    <div class="flex flex-col items-center">
                        <!-- Champ OTP -->
                        <div class="w-full max-w-xs mb-4">
                            <input
                                #otpInput
                                formControlName="codeOtp"
                                type="text"
                                maxlength="4"
                                [ngClass]="{
                                    'border-red-500': f['codeOtp'].invalid && (f['codeOtp'].touched || submitted),
                                    'border-green-500': f['codeOtp'].valid && (f['codeOtp'].touched || submitted)
                                }"
                                class="tracking-[12px] sm:tracking-[16px] otp-input w-full h-14 sm:h-16 text-center text-xl sm:text-2xl font-bold border-2 rounded-md focus:outline-none focus:ring-2 focus:ring-[#F39200] focus:border-[#F39200] placeholder-gray-300 transition-all duration-200"
                                placeholder="----"
                            />
                            
                            <!-- Messages d'erreur -->
                            <div *ngIf="f['codeOtp'].invalid && (f['codeOtp'].touched || submitted)" class="text-red-500 text-xs mt-2 text-center">
                                <div *ngIf="f['codeOtp'].errors?.['required']">
                                    Le code OTP est requis
                                </div>
                                <div *ngIf="f['codeOtp'].errors?.['minlength'] || f['codeOtp'].errors?.['maxlength']">
                                    Le code doit contenir exactement 4 chiffres
                                </div>
                                <div *ngIf="f['codeOtp'].errors?.['pattern']">
                                    Seuls les chiffres sont autorisés
                                </div>
                            </div>
                        </div>
                    
                        <!-- Bouton de soumission -->
                        <button
                            type="submit"
                            [disabled]="otpForm.invalid || isLoading"
                            [ngClass]="{
                                'bg-[#F39200] hover:bg-[#E68600] shadow-lg hover:shadow-xl': otpForm.valid && !isLoading,
                                'bg-gray-400 cursor-not-allowed': otpForm.invalid || isLoading
                            }"
                            class="w-full max-w-xs py-3 sm:py-4 text-white border-none rounded-md text-base sm:text-lg font-medium transition-all duration-200 flex items-center justify-center gap-2 transform hover:scale-[1.02] active:scale-[0.98]"
                        >
                            <svg
                                *ngIf="isLoading"
                                class="slow-spin h-5 w-5 text-white"
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                            >
                                <circle
                                    class="opacity-25"
                                    cx="12"
                                    cy="12"
                                    r="10"
                                    stroke="currentColor"
                                    stroke-width="4"
                                ></circle>
                                <path
                                    class="opacity-75"
                                    fill="currentColor"
                                    d="M4 12a8 8 0 018-8v4l3-3-3-3v4a8 8 0 00-8 8h4z"
                                ></path>
                            </svg>
                            Vérifier
                        </button>
                    
                        <!-- Section Renvoyer OTP -->
                        <div class="text-center mt-6 w-full max-w-xs">
                            @if (!showResend) {
                                <button 
                                    (click)="renvoyerOtp()"
                                    class="text-[#F39200] text-sm sm:text-base hover:underline bg-transparent border-none cursor-pointer p-2 hover:bg-orange-50 rounded-md transition-all duration-200"
                                    [disabled]="isLoading"
                                >
                                    <span class="inline-flex items-center gap-1">
                                        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"></path>
                                        </svg>
                                        Renvoyer le code OTP
                                    </span>
                                </button>
                            } @else {
                                <div class="inline-flex items-center bg-gray-100 rounded-full px-4 py-3 sm:px-6 sm:py-3">
                                    <svg class="w-4 h-4 mr-2 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                                    </svg>
                                    <span class="text-gray-600 text-sm mr-2">Nouveau code dans</span>
                                    <span class="font-mono font-bold text-[#016934] text-base">
                                        {{ minutes }}:{{ seconds < 10 ? '0' + seconds : seconds }}
                                    </span>
                                </div>
                            }
                        </div>
                    </div>
                </form>
            </div>
        </div>
    
        <!-- Footer -->
        <div class="text-center text-[#F39200] text-sm sm:text-base py-4 sm:py-6 px-4">
            ONECI 2025 - Tous droits réservés
        </div>
    </div>
</div>
